import { StyleSheet } from 'aphrodite'

const style = {
  box: {
    width: `45px`,
    height: `45px`,
    borderRadius: `3px`
  },
  span: {
    fontSize: `14px`
  }
}

export default StyleSheet.create(style)



// WEBPACK FOOTER //
// ./src/components/User/partials/UserTable/partials/Avatar/style/index.js